<template>
    <layout>
        <article class="news news--single">
            <div class="container-fluid pb-3 pt-3">
                <header class="news__header">
                    <h1 class="news__title">{{ newTitle }}</h1>
                    <h2 class="news__subtitle mb-0">{{ newSubtitle }}</h2>
                    <time class="mt-0" :datetime="timeSI" pubdate>{{ timeText }}</time>
                </header>
                <figure v-if="newThumbnail" class="news__figure">
                    <picture>
                        <img class="img-fluid" :src="newThumbnail" loading="lazy" :alt="`Imagem capa da notícia - ${newTitle}`" />
                    </picture>
                </figure>
                <div class="news__content ck-content" v-html="newContent" />
                <div class="news__files" v-if="newFiles.length > 0">
                    <h3>Ficheiros</h3>
                    <a
                        class="news__file"
                        target="_blank"
                        v-for="(file,index) in newFiles"
                        :href="file.path"
                        :key="index">
                        {{ file.name }}
                    </a>
                </div>
            </div>
        </article>
    </layout>
</template>

<script>
    import mixin from '../../mixin';
    import layout from '../../layouts/Main.vue';
    import { formatUrl } from '@config/utils';

    export default {
        mixins: [
            mixin
        ],
        props: {
            slug: {
                type: String,
                required: true,
            },
            preview: {
                type: String,
                default: null,
                validator: function (prop) {
                    let valid = [
                        'preview',
                    ];
                    return valid.includes(prop);
                }
            }
        },
        components: {
            layout,
        },
        data() {
            return {
                pageID: 'news',
                newData: {
                    title: null,
                    subtitle: null,
                    content: null,
                    published_at: null,
                    thumbnail: null,
                    files: [],
                },
            }
        },
        mounted() {
            this.loadPage()
        },
        beforeRouteLeave: function(to, from, next) {
            this.$store.dispatch('breadcrumbChanged', {label: from.meta.defaultTitle});
            next();
        },
        computed: {
            newTitle() {
                return this.newData.title;
            },
            newSubtitle() {
                return this.newData.subtitle;
            },
            newContent() {
                let content = this.newData.content ?? '';
                // content = content.replace('oembed', 'iframe');
                // content = content.replace('url', 'src');
                // content = content.replace('watch?v=', 'embed/');
                // content = content.replace('oembed', 'iframe');
                return content;
            },
            newPublished() {
                return this.newData.published_at;
            },
            newThumbnail() {
                return this.newData.thumbnail;
            },
            newFiles() {
                return this.newData.files ?? [];
            },
            timeText() {
                return this.newPublished ? moment(this.newPublished).format('D [de] MMMM [de] YYYY[,] hh:mm') : null;
            },
            timeSI() {
                return this.newPublished ? moment(this.newPublished).format('YYYY-MM-DD hh:mm') : null;
            },
        },
        methods: {
            async loadPage() {
                let url = this.url.getSingle;
                if(!url) return;

                const params = {
                    slug: this.slug,
                    locale: this.locale,
                    preview: this.preview,
                };

                return await this.$http(formatUrl(url, params))
                .then(({data}) => {
                    this.newData = data;
                    this.$store.dispatch('breadcrumbChanged', {label: this.newTitle});
                    return true;
                }).catch((err) => {
                    this.showError(err);
                    return false;
                });
            }
        },
    }
</script>

